import {CurrentUser} from "./CurrentUser";
import {permissionDefinition} from "../reducers/authentication/permissionDefinition";

class PermissionService {
    getCurrentPermission() {
        const currentRole = CurrentUser.applicationRole;

        return  permissionDefinition[currentRole] || permissionDefinition["None"];
    }

    showSettings() {
        const permission = this.getCurrentPermission();
        return permission.settingsAccess;
    }

    getStartPage() {
        const permission = this.getCurrentPermission();
        return permission.startPage;
    }

    canCustomerAccessNrisk() {
        return CurrentUser.hasProductSubscription("Nrisk");
    }

    canCustomerAccessNfindings() {
        return CurrentUser.hasProductSubscription("Nfindings");
    }
}
const svc = new PermissionService();
export default svc;
